<template>
	<CFooter :fixed="false">
		<div>
			<span class="ml-1">&copy; {{ new Date().getFullYear() }} Colikado.</span>
		</div>
	</CFooter>
</template>

<script>
	export default {
		name: 'TheFooter',
	};
</script>
